import styled from 'styled-components';
import {flexWrap, message, text, title} from '../../promotionMessage/PromotionMessage.css';
import {mobileMedia, tabletMedia} from '../../../globalVariables/GlobalVariables';
import {dFlex} from '../../../globalVariables/GlobalFlex';
import {Close} from '../../close/Close.css';
import {btn} from '../../button/btn/Btn.css';
import {popUpBody} from '../../newPopup/mobilePopup/MobilePopup.css';
import {popUpTop} from '../../newPopup/topPopup/TopPopup.css';

export const promotionMessage = styled.div`
    position: relative;
    inset-block-start: 30px;
    ${message}{
        height: 89px;
        padding-inline-start: 40px;
        padding-inline-end: 20px;
        ${mobileMedia}{
            padding-inline: 10px;
            padding-block: 10px;
        }
        &.show{
            &::before{
                inset-inline-end: 100px;
                inset-inline-start: unset;
                width: 161px;
                height: 91px;
                ${mobileMedia}{
                    display: none;
                }
            }
        }
    }
    ${flexWrap}{
        ${tabletMedia}{
            ${dFlex};
        }
    }
    ${title}{
        font-size: 20px;
        line-height: 100%;
        width: 60%;
        ${mobileMedia}{
            font-size: 18px;
        }
    }
    ${text}{
        font-size: 14px;
        line-height: 100%;
        margin-block: 5px;
        width: 50%;
        ${mobileMedia}{
            font-size: 12px;
            width: 100%;
        }
    }
    ${Close}{
        display: none;
    }
    ${btn}{
        padding: 7px 16px;
        font-size: 12px;
        line-height: normal;
        height: min-content;
        ${tabletMedia}{
            height: min-content;
            padding: 7px 16px;
            font-size: 12px;
            line-height: normal;
            height: min-content;
            inset-block-end: 10px;
        }
    }
`;

export const promotionPopup = styled.div`
    ${popUpTop}{
        background-color: transparent;
        height: 50px;
    }
    ${popUpBody} {
        height: max-content;
        max-height: calc(100% - 200px);
        width: 440px;
    }
`;
export const popupTitle = styled.div`
    font-size: 20px;
    line-height: 100%;
    margin-block: 5px;
`;

export const popupText = styled.div`
    font-size: 16px;
    line-height: 100%;
    margin-block: 5px;
`;
export const popupContact = styled.div`
    font-size: 14px;
    line-height: 100%;
    margin-block: 5px;
`;